module.exports = __webpack_public_path__ + "img/kakao.5d4418b.svg";